export default __webpack_public_path__ + "static/img/silo.1e73adb.png";